import React from 'react';
import AppConfig from '../../config/app-config';
import UploadSceneView from './upload-scene-view';

function UploadSceneProvider({ ...props }) {
  return (
    <UploadSceneView
      {...AppConfig.Copy.UploadPage}
      {...props}
    />
  );
}

export default UploadSceneProvider;
